import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-showHint';
	$(base, context).each(function(){
		var component = $(this);
		var hint = component.siblings('.b-hint');
		var close = hint.find('.b-hint-close');

		component.on('click', function() {
			hint.addClass('m-active');
		});

		close.on('click', function() {
			hint.removeClass('m-active');
		});
	});
});
